import {useState, useCallback} from 'react'
import {PutBooking} from '../../../redux/CustomerDelegateCRUD'
import {useFormik} from 'formik'
import {BookingPortalForm, roleFormValidationSchema} from './BookingPortalForm'
import {Drawer} from '../../../../../components/Drawer/Drawer'
import {useDrawerRef} from '../../../../../components/Drawer/useDrawerRef'
import {useAlerts} from '../../../../../components/alerts/useAlerts'
import {getBookingPayload, initialValues} from '../../../hooks/useFormDrawerBookingData'
import {BookingPortalFormValues} from './BookingPortalForm'
import {BookingModel} from '../../../../../models/ems/BookingModel'
import {useFormDrawerBookingData} from '../../../hooks/useFormDrawerBookingData'
import {useOnChange} from '../../../../../components/hooks/useOnChange'
import {EventModel} from '../../../../../models/ems/EventModel'
import {CustomerModel} from '../../../../../models/CustomerModel'
// import {useDispatch} from 'react-redux'
// import {actions} from '../../../redux/CustomerPortalRedux'
export interface BookingFormEditProps {
  drawerRef: (drawer: Drawer | null) => void
  onChange: () => void
  onRefreshCallback?: () => void
  bookingToEdit?: BookingModel
  event?: EventModel
  customer?: CustomerModel
}

const BookingPortalFormEdit = ({
  drawerRef,
  onRefreshCallback,
  onChange,
  bookingToEdit,
  event,
  customer,
}: BookingFormEditProps) => {
  const [loading, setLoading] = useState(false)
  const [drawer, setDrawer] = useDrawerRef()
  const {pushError} = useAlerts()
  const formDrawer = useFormDrawerBookingData()
  const [isOpen, setIsOpen] = useState(false)
  // const dispatch = useDispatch()

  const editBooking = useCallback(
    async (values: BookingPortalFormValues) => {
      const payload = getBookingPayload(values)
      try {
        if (bookingToEdit?.code) await PutBooking(payload, bookingToEdit?.code)
        onChange()
        if (onRefreshCallback) {
          // dispatch(actions.bookingProducts.search())
          onRefreshCallback()
        }
      } catch (e) {
        pushError(e)
      }
    },
    [bookingToEdit?.code, onChange, onRefreshCallback, pushError]
  )

  useOnChange(bookingToEdit, () => {
    if (bookingToEdit) {
      const values = formDrawer.mapBookingDataToFormValues(bookingToEdit)
      formik.setValues(values)
    }
  })

  const formik = useFormik({
    initialValues,
    validateOnMount: true,
    validationSchema: roleFormValidationSchema,
    onSubmit: async (values, {setSubmitting}) => {
      setLoading(true)
      try {
        await editBooking(values)

        handleCloseDrawer()
        drawer?.hide()
      } catch (e) {
        pushError(e)
      } finally {
        setLoading(false)
        setSubmitting(false)
      }
    },
  })

  const handleCloseDrawer = useCallback(() => {
    formik.resetForm()
    setIsOpen(false)
    if (event) formik.setFieldValue('eventCode', event?.code)
    if (customer)
      formik.setFieldValue('customer', {
        label: customer.name,
        value: customer.code,
      })
  }, [customer, event, formik])

  const handleDrawerRef = useCallback(
    (drawer: Drawer) => {
      drawerRef(drawer)
      setDrawer(drawer)
    },
    [drawerRef, setDrawer]
  )

  return (
    <Drawer onOpen={() => setIsOpen(true)} ref={handleDrawerRef} onClose={handleCloseDrawer}>
      <BookingPortalForm
        title='Edit Booking'
        onCloseButtonClick={drawer?.hide}
        isLoading={loading}
        formik={formik}
        event={event}
        isOpen={isOpen}
        customer={customer}
      />
    </Drawer>
  )
}

export default BookingPortalFormEdit
